// extracted by mini-css-extract-plugin
module.exports = {"Addition":"index_Addition__vyfoj","input":"index_input__1UHcx","opt":"index_opt__35wcr","disabled":"index_disabled__1NHH3"};